import { makeStyles } from "@material-ui/core/styles"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	icon: {
		cursor: "pointer",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: colors.gray[400],
		width: 14
	}
}))

export default useStyles
